// extracted by mini-css-extract-plugin
export default {"messageContainer":"UCVfj","messageContainerWithoutIcon":"CyyXO UCVfj","icon":"_71FhV","text":"kDZAI","hideIcon":"CtKk9"};